import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from './client';
import type { CompanySettings, UpdateCompanySettings } from '@estimator/shared';

export function useCompanySettings() {
  return useQuery({
    queryKey: ['company-settings'],
    queryFn: async () => {
      const { data } = await apiClient.get<CompanySettings>('/company-settings');
      return data;
    },
  });
}

export function useUpdateCompanySettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (body: UpdateCompanySettings) => {
      const { data } = await apiClient.patch<CompanySettings>('/company-settings', body);
      return data;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['company-settings'] }),
  });
}
